"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DeviceTypeContext_types_1 = require("./DeviceTypeContext.types");
function mapDeviceTypeToServerDeviceType(device) {
    if (device === DeviceTypeContext_types_1.DeviceType.Mobile) {
        return `MOBILE`;
    }
    return `DESKTOP`;
}
exports.default = mapDeviceTypeToServerDeviceType;
//# sourceMappingURL=mapDeviceTypeToServerDeviceType.js.map